export type FavoriteSortBy = 'RECENTLY_ADDED' | 'ASCENDING_PRICE' | 'AROUND_ME'

export enum Tab {
  OFFERS = 'Offres',
  VENUES = 'Lieux',
  ARTISTS = 'Artistes',
}
